import { AuthenticatedProvider, DocumentProvider, Layout, useScreen, withAnalytics, withSagas } from 'metrix-common3';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { chargeCard } from '../../actions/payment/chargeCard';
import { createPaymentTransferResultRecord } from '../../actions/payment/createPaymentTransferResultRecord';
import { getPaymentEmail } from '../../actions/payment/getPaymentEmail';
import { getPaymentTransferResultRecords } from '../../actions/payment/getPaymentTransferResultRecords';
import { reducePaymentEmail } from '../../actions/payment/reducePaymentEmail';
import { reducePaymentTransferResultRecords } from '../../actions/payment/reducePaymentTransferResultRecords';
import { sendPaymentLink } from '../../actions/payment/sendPaymentLink';
import { applyPolicyAdjustment } from '../../actions/policy/applyPolicyAdjustment';
import { applyPolicyAdjustmentChanges } from '../../actions/policy/applyPolicyAdjustmentChanges';
import { completeCancellation } from '../../actions/policy/completeCancellation';
import { createCancellation } from '../../actions/policy/createCancellation';
import { createEndorsement } from '../../actions/policy/createEndorsement';
import { deleteCancellation } from '../../actions/policy/deleteCancellation';
import { deletePolicyAdjustment } from '../../actions/policy/deletePolicyAdjustment';
import { executePolicyAction } from '../../actions/policy/executePolicyAction';
import { executePolicyTransactionCustomAction } from '../../actions/policy/executePolicyTransactionCustomAction';
import { getCancellation } from '../../actions/policy/getCancellation';
import { getLogContent } from '../../actions/policy/getLogContent';
import { getLogs } from '../../actions/policy/getLogs';
import { getNotes } from '../../actions/policy/getNotes';
import { getOpta } from '../../actions/policy/getOpta';
import { getOptaEstimator } from '../../actions/policy/getOptaEstimator';
import { getOverridableErrors } from '../../actions/policy/getOverridableErrors';
import { getPolicy } from '../../actions/policy/getPolicy';
import { getPolicyAdjustments } from '../../actions/policy/getPolicyAdjustments';
import { getPolicySummary } from '../../actions/policy/getPolicySummary';
import { getPolicyTerms } from '../../actions/policy/getPolicyTerms';
import { getPolicyTestOverride } from '../../actions/policy/getPolicyTestOverride';
import { getPolicyValidationInfo } from '../../actions/policy/getPolicyValidationInfo';
import { getTooltipInfo } from '../../actions/policy/getTooltipInfo';
import { getUnderwriterReviewLink } from '../../actions/policy/getUnderwriterReviewLink';
import { overrideCancellationRefund } from '../../actions/policy/overrideCancellationRefund';
import { queryPolicy } from '../../actions/policy/queryPolicy';
import { quoteCancellation } from '../../actions/policy/quoteCancellation';
import { reduceCancellationResult } from '../../actions/policy/reduceCancellationResult';
import { reduceEntity } from '../../actions/policy/reduceEntity';
import { reduceParameter } from '../../actions/policy/reduceParameter';
import { reduceParameters } from '../../actions/policy/reduceParameters';
import { reducePolicyElement } from '../../actions/policy/reducePolicyElement';
import { reduceTooltipInfoElement } from '../../actions/policy/reduceTooltipInfoElement';
import { regenerateDocuments } from '../../actions/policy/regenerateDocuments';
import { sendEmailRequest } from '../../actions/policy/sendEmailRequest';
import { setEndorsementToLost } from '../../actions/policy/setEndorsementToLost';
import { setPolicyTestOverride } from '../../actions/policy/setPolicyTestOverride';
import { updateCancellationDate } from '../../actions/policy/updateCancellationDate';
import { updatePlace } from '../../actions/policy/updatePlace';
import { upsertNote } from '../../actions/policy/upsertNotes';
import { upsertPolicy } from '../../actions/policy/upsertPolicy';
import { upsertTooltipInfo } from '../../actions/policy/upsertTooltipInfo';
import AppBar from '../../components/AppBar';
import ProfileDocuments from '../../components/Profile/Documents';
import ProfileDrivers from '../../components/Profile/Drivers';
import ProfileDwellings from '../../components/Profile/Dwellings';
import ProfileHistory from '../../components/Profile/History';
import ProfileInsured from '../../components/Profile/Insured';
import LiabilityExposures from '../../components/Profile/LiabilityExposures';
import ProfileLogs from '../../components/Profile/Logs';
import ProfileNotes from '../../components/Profile/Notes';
import ProfilePayment from '../../components/Profile/Payment';
import ProfilePolicy from '../../components/Profile/Policy';
import ProfileRenewal from '../../components/Profile/Renewal';
import ProfileResidents from '../../components/Profile/Residents';
import ProfileSecureMyOfferAdditionalSellers from '../../components/Profile/SecureMyOffer/AdditionalContacts';
import ProfileInsuranceApplicant from '../../components/Profile/SecureMyOffer/InsuranceApplicant';
import ProfileSecureMyOfferOfferInfo from '../../components/Profile/SecureMyOffer/OfferInfo';
import ProfileSideBar from '../../components/Profile/SideBar';
import ProfileSummary from '../../components/Profile/Summary';
import ProfileSupernovaCommercialBusinessInfo from '../../components/Profile/SupernovaCommercial/BusinessInfo';
import ProfileSupernovaCommercialCoverages from '../../components/Profile/SupernovaCommercial/Coverages';
import ProfileSupernovaCommercialEmployment from '../../components/Profile/SupernovaCommercial/Employment';
import ProfileSupernovaCommercialInsuranceHistory from '../../components/Profile/SupernovaCommercial/InsuranceHistory';
import ProfileSupernovaCommercialInsureds from '../../components/Profile/SupernovaCommercial/Insureds';
import ProfileSupernovaCommercialLossPayees from '../../components/Profile/SupernovaCommercial/LossPayees';
import ProfileSupernovaCommercialMemberships from '../../components/Profile/SupernovaCommercial/Memberships';
import ProfileTerms from '../../components/Profile/Terms';
import ProfileTestMode from '../../components/Profile/TestMode';
import ProfileUnderwriterCoverageAdjustment from '../../components/Profile/UnderwriterCoverageAdjustment';
import ProfileVehicles from '../../components/Profile/Vehicles';
import ProductHelper from '../../helpers';
import paymentSaga from '../../sagas/payment/saga';
import policySaga from '../../sagas/policy/saga';
import { selectPaymentEmail } from '../../selectors/payment/selectPaymentEmail';
import { selectPaymentTransferResultErrors } from '../../selectors/payment/selectPaymentTransferResultErrors';
import { selectPaymentTransferResultHidden } from '../../selectors/payment/selectPaymentTransferResultHidden';
import { selectPaymentTransferResultReadOnly } from '../../selectors/payment/selectPaymentTransferResultReadOnly';
import { selectPaymentTransferResultRecords } from '../../selectors/payment/selectPaymentTransferResultRecords';
import { selectSendPaymentLinkDto } from '../../selectors/payment/selectSendPaymentLinkDto';
import { selectAllowEdit } from '../../selectors/policy/selectAllowEdit';
import { selectCancellation } from '../../selectors/policy/selectCancellation';
import { selectCancellationResult } from '../../selectors/policy/selectCancellationResult';
import { selectEndorsementResult } from '../../selectors/policy/selectEndorsementResult';
import { selectEntity } from '../../selectors/policy/selectEntity';
import { selectNotes } from '../../selectors/policy/selectNotes';
import { selectOverridableErrors } from '../../selectors/policy/selectOverridableErrors';
import { selectParameters } from '../../selectors/policy/selectParameters';
import { selectPolicy } from '../../selectors/policy/selectPolicy';
import { selectPolicyAdjustments } from '../../selectors/policy/selectPolicyAdjustments';
import { selectPolicyHistory } from '../../selectors/policy/selectPolicyHistory';
import { selectPolicyLogs } from '../../selectors/policy/selectPolicyLogs';
import { selectPolicySummary } from '../../selectors/policy/selectPolicySummary';
import { selectPolicyTerms } from '../../selectors/policy/selectPolicyTerms';
import { selectPolicyTestOverride } from '../../selectors/policy/selectPolicyTestOverride';
import { selectPolicyValidationInfo } from '../../selectors/policy/selectPolicyValidationInfo';
import { selectProductSettings } from '../../selectors/policy/selectProductSettings';
import { selectRiskChanged } from '../../selectors/policy/selectRiskChanged';
import { selectTooltipInfo } from '../../selectors/policy/selectTooltipInfo';

const Footer = styled.div`
    ${({ apply }) => apply && 'height: 60px;'}
`;

const Profile = (props) => {
    const screen = useScreen();
    const location = useLocation();

    const [activeTab, setActiveTab] = useState(null);
    const [entity, _setEntity] = useState(null);

    const prevPolicyId = useRef(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const entityParam = params.get('entity');
        props.doReduceEntity(entityParam);
        props.doGetPolicySummary();
        props.doGetPolicy();
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: only re-run on listed deps
    useEffect(() => {
        if (props.policy && props.policy.id !== prevPolicyId.current) {
            props.doGetTooltipInfo(props.policy.product);
            props.doGetPolicyValidationInfo();
        }
        prevPolicyId.current = props.policy?.id;
    }, [props.policy?.id]);

    const desktop = screen?.isDesktop;
    const isAdmin = props.context.session.userType === 'administrator';
    const isBroker = props.context.session.userType === 'broker';
    const isRenewal = props.policySummary && props.policySummary.type === 'renewal';
    const allowEdit = props.allowEdit;

    const baseProps = {
        changeTabTo: (value) => {
            window.location.hash = value;
            setActiveTab(value);
        },
        activeTab,
        entity,
        ...props,
    };
    const commonProps = {
        pageCode: activeTab,
        allowEdit: props.allowEdit,
        policy: props.policy,
        doGetPolicy: props.doGetPolicy,
        doUpsertPolicy: props.doUpsertPolicy,
        doReducePolicyElement: props.doReducePolicyElement,
        reference: props.reference,
        doReduceTooltipInfoElement: props.doReduceTooltipInfoElement,
        tooltipInfo: props.tooltipInfo,
        validationInfo: props.validationInfo,
        doUpsertTooltipInfo: props.doUpsertTooltipInfo,
        doUpdatePlace: props.doUpdatePlace,
        context: props.context,
        productSettings: props.productSettings,
    };

    return (
        <AuthenticatedProvider {...props}>
            <Layout
                fullScreen
                appbar={<AppBar {...props} />}
                loading={props.context.loading}
                sideContent={
                    (isAdmin || isBroker) &&
                    props.policySummary && (
                        <ProfileSideBar
                            activeTab={activeTab}
                            setActiveTab={(value) => setActiveTab(value)}
                            {...props}
                        />
                    )
                }
            >
                {props.policy && (
                    <>
                        <DocumentProvider {...props}>
                            {(isAdmin || isBroker) && activeTab === 'documents' && (
                                <ProfileDocuments
                                    pageCode={activeTab}
                                    riskChanged={props.riskChanged}
                                    allowEdit={allowEdit}
                                    {...props}
                                />
                            )}
                            {(activeTab === 'summary' || activeTab === null) && !isRenewal && (
                                <ProfileSummary
                                    pageCode={activeTab}
                                    allowEdit={allowEdit}
                                    doSendPaymentLink={props.doSendPaymentLink}
                                    doChargeCard={props.doChargeCard}
                                    doGetPaymentEmail={props.doGetPaymentEmail}
                                    doReducePaymentEmail={props.doReducePaymentEmail}
                                    doExecutePolicyTransactionCustomAction={
                                        props.doExecutePolicyTransactionCustomAction
                                    }
                                    paymentEmail={props.paymentEmail}
                                    {...baseProps}
                                />
                            )}
                            {(activeTab === 'renewal' || activeTab === null) && isRenewal && (
                                <ProfileRenewal {...baseProps} />
                            )}
                        </DocumentProvider>
                        {(isAdmin || isBroker) && activeTab === 'terms' && (
                            <ProfileTerms
                                context={props.context}
                                pageCode={activeTab}
                                policyTerms={props.policyTerms}
                                doGetPolicyTerms={props.doGetPolicyTerms}
                            />
                        )}
                        {isAdmin &&
                            activeTab === 'underwriterCoverageAdjustment' &&
                            props.policySummary?.status === 'quoteAccepted' && (
                                <ProfileUnderwriterCoverageAdjustment
                                    context={props.context}
                                    pageCode={activeTab}
                                    policyAdjustments={props.policyAdjustments}
                                    doGetPolicyAdjustments={props.doGetPolicyAdjustments}
                                    doApplyPolicyAdjustment={props.doApplyPolicyAdjustment}
                                    doApplyPolicyAdjustmentChanges={props.doApplyPolicyAdjustmentChanges}
                                    doDeletePolicyAdjustment={props.doDeletePolicyAdjustment}
                                />
                            )}
                        {(isAdmin || isBroker) &&
                            activeTab === 'liabilityExposure' &&
                            ProductHelper.hasLiabilityExposures(props.policySummary?.product) && (
                                <LiabilityExposures pageCode={activeTab} allowEdit={allowEdit} {...props} />
                            )}
                        {(isAdmin || isBroker) && activeTab === 'policy' && (
                            <ProfilePolicy pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'applicant' && (
                            <ProfileInsured pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'securemyoffer.insuranceApplicant' && (
                            <ProfileInsuranceApplicant pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}

                        {(isAdmin || isBroker) && activeTab === 'auto.drivers' && (
                            <ProfileDrivers pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'auto.vehicles' && (
                            <ProfileVehicles pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'usauto.drivers' && (
                            <ProfileDrivers pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'usauto.vehicles' && (
                            <ProfileVehicles pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'home.residents' && (
                            <ProfileResidents pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'home.dwellings' && (
                            <ProfileDwellings pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'ushome.residents' && (
                            <ProfileResidents pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'ushome.dwellings' && (
                            <ProfileDwellings pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}

                        {(isAdmin || isBroker) && activeTab === 'sn-commercial.business' && (
                            <ProfileSupernovaCommercialBusinessInfo {...commonProps} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'sn-commercial.employment' && (
                            <ProfileSupernovaCommercialEmployment {...commonProps} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'sn-commercial.memberships' && (
                            <ProfileSupernovaCommercialMemberships {...commonProps} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'sn-commercial.insuranceHistory' && (
                            <ProfileSupernovaCommercialInsuranceHistory {...commonProps} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'sn-commercial.coverages' && (
                            <ProfileSupernovaCommercialCoverages {...commonProps} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'sn-commercial.additionalInsureds' && (
                            <ProfileSupernovaCommercialInsureds pageCode={activeTab} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'sn-commercial.lossPayees' && (
                            <ProfileSupernovaCommercialLossPayees pageCode={activeTab} {...props} />
                        )}

                        {(isAdmin || isBroker) && activeTab === 'securemyoffer.secureMyOffer' && (
                            <ProfileSecureMyOfferOfferInfo pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'securemyoffer.additionalSellers' && (
                            <ProfileSecureMyOfferAdditionalSellers
                                pageCode={activeTab}
                                allowEdit={allowEdit}
                                {...props}
                            />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'payment' && (
                            <ProfilePayment pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'notes' && (
                            <ProfileNotes
                                context={props.context}
                                notes={props.notes}
                                doGetNotes={props.doGetNotes}
                                doUpsertNote={props.doUpsertNote}
                            />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'history' && (
                            <ProfileHistory pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {(isAdmin || isBroker) && activeTab === 'logs' && (
                            <ProfileLogs pageCode={activeTab} allowEdit={allowEdit} {...props} />
                        )}
                        {isAdmin && activeTab === 'testMode' && (
                            <ProfileTestMode
                                context={props.context}
                                policyTestOverride={props.policyTestOverride}
                                doGetPolicyTestOverride={props.doGetPolicyTestOverride}
                                doSetPolicyTestOverride={props.doSetPolicyTestOverride}
                            />
                        )}
                        <Footer apply={!desktop} />
                    </>
                )}
            </Layout>
        </AuthenticatedProvider>
    );
};

const mapStateToProps = createStructuredSelector({
    policy: selectPolicy(),
    policySummary: selectPolicySummary(),
    productSettings: selectProductSettings(),
    policyHistory: selectPolicyHistory(),
    policyLogs: selectPolicyLogs(),
    entity: selectEntity(),
    parameters: selectParameters(),
    validationInfo: selectPolicyValidationInfo(),
    tooltipInfo: selectTooltipInfo(),
    allowEdit: selectAllowEdit(),
    riskChanged: selectRiskChanged(),
    paymentEmail: selectPaymentEmail(),
    sendPaymentLinkDto: selectSendPaymentLinkDto(),
    paymentTransferResultRecords: selectPaymentTransferResultRecords(),
    paymentTransferResultErrors: selectPaymentTransferResultErrors(),
    paymentTransferResultReadOnly: selectPaymentTransferResultReadOnly(),
    paymentTransfersResultHidden: selectPaymentTransferResultHidden(),
    notes: selectNotes(),
    policyAdjustments: selectPolicyAdjustments(),
    overridableErrors: selectOverridableErrors(),
    policyTestOverride: selectPolicyTestOverride(),
    endorsementResult: selectEndorsementResult(),
    cancellation: selectCancellation(),
    cancellationResult: selectCancellationResult(),
    policyTerms: selectPolicyTerms(),
});

function mapDispatchToProps(dispatch) {
    return {
        doGetPolicy: () => dispatch(getPolicy()),
        doGetPolicySummary: () => dispatch(getPolicySummary()),
        doGetPolicyValidationInfo: () => dispatch(getPolicyValidationInfo()),
        doReducePolicyElement: (payload) => dispatch(reducePolicyElement(payload)),
        doQueryPolicy: () => dispatch(queryPolicy()),
        doExecutePolicyAction: (payload) => dispatch(executePolicyAction(payload)),
        doExecutePolicyTransactionCustomAction: (payload) => dispatch(executePolicyTransactionCustomAction(payload)),
        doUpsertPolicy: () => dispatch(upsertPolicy()),
        doReduceEntity: (payload) => dispatch(reduceEntity(payload)),
        doReduceParameter: (payload) => dispatch(reduceParameter(payload)),
        doReduceParameters: (payload) => dispatch(reduceParameters(payload)),
        doGetLogs: (payload) => dispatch(getLogs(payload)),
        doGetLogContent: (payload) => dispatch(getLogContent(payload)),
        doGetTooltipInfo: (payload) => dispatch(getTooltipInfo(payload)),
        doReduceTooltipInfoElement: (payload) => dispatch(reduceTooltipInfoElement(payload)),
        doUpsertTooltipInfo: (payload) => dispatch(upsertTooltipInfo(payload)),
        doGetOpta: (payload) => dispatch(getOpta(payload)),
        doGetOptaEstimator: (payload) => dispatch(getOptaEstimator(payload)),
        doSendEmailRequest: (payload) => dispatch(sendEmailRequest(payload)),
        doUpdatePlace: (payload) => dispatch(updatePlace(payload)),
        doSendPaymentLink: () => dispatch(sendPaymentLink()),
        doChargeCard: () => dispatch(chargeCard()),
        doGetPaymentEmail: () => dispatch(getPaymentEmail()),
        doReducePaymentEmail: (payload) => dispatch(reducePaymentEmail(payload)),
        doGetPaymentTransferResultRecords: () => dispatch(getPaymentTransferResultRecords()),
        doCreatePaymentTransferResultRecord: () => dispatch(createPaymentTransferResultRecord()),
        doReducePaymentTransferResultRecords: (payload) => dispatch(reducePaymentTransferResultRecords(payload)),
        doGetNotes: (payload) => dispatch(getNotes(payload)),
        doUpsertNote: (payload) => dispatch(upsertNote(payload)),
        doRegenerateDocuments: (payload) => dispatch(regenerateDocuments(payload)),
        doGetUnderwriterReviewLink: (payload) => dispatch(getUnderwriterReviewLink(payload)),
        doGetPolicyAdjustments: () => dispatch(getPolicyAdjustments()),
        doApplyPolicyAdjustment: (payload) => dispatch(applyPolicyAdjustment(payload)),
        doApplyPolicyAdjustmentChanges: (payload) => dispatch(applyPolicyAdjustmentChanges(payload)),
        doDeletePolicyAdjustment: (payload) => dispatch(deletePolicyAdjustment(payload)),
        doGetOverridableErrors: () => dispatch(getOverridableErrors()),
        doGetPolicyTestOverride: () => dispatch(getPolicyTestOverride()),
        doSetPolicyTestOverride: (payload) => dispatch(setPolicyTestOverride(payload)),
        doCreateEndorsement: (payload) => dispatch(createEndorsement(payload)),
        doSetEndorsementToLost: (payload) => dispatch(setEndorsementToLost(payload)),
        doCreateCancellation: (payload) => dispatch(createCancellation(payload)),
        doQuoteCancellation: (payload) => dispatch(quoteCancellation(payload)),
        doDeleteCancellation: (payload) => dispatch(deleteCancellation(payload)),
        doUpdateCancellationDate: (payload) => dispatch(updateCancellationDate(payload)),
        doGetCancellation: (payload) => dispatch(getCancellation(payload)),
        doReduceCancellationResult: (payload) => dispatch(reduceCancellationResult(payload)),
        doOverrideCancellationRefund: (payload) => dispatch(overrideCancellationRefund(payload)),
        doCompleteCancellation: (payload) => dispatch(completeCancellation(payload)),
        doGetPolicyTerms: () => dispatch(getPolicyTerms()),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withPolicySaga = withSagas({ key: 'policy', saga: policySaga });
const withPaymentSaga = withSagas({ key: 'payment', saga: paymentSaga });

const WrappedProfile = withAnalytics(Profile, true);

export default compose(withConnect, withPolicySaga, withPaymentSaga)(WrappedProfile);
